import React from 'react';
import styles from './wavyConnectorLine.module.css';
import { WavyConnectorLineProps } from './wavyConnectorLine.types';

const WavyConnectorLine: React.FC<WavyConnectorLineProps> = ({
  line,
  active = false,
  strokeWidth = 2,
  dashArray = '6,4',
  className = '',
}) => {
  const strokeColor = active ? '#6E55F5' : '#BCBCBC';
  const xOffset = 15;

  const { x1, y1 } = line;
  const x2 = line.x2 - xOffset;
  const y2 = line.y2;

  const midX = (x1 + x2) / 2;
  const pathD = `M ${x1},${y1} C ${midX},${y1} ${midX},${y2} ${x2},${y2}`;

  return (
    <svg
      className={`absolute top-0 left-0 w-full h-full z-0 pointer-events-none ${className}`}
    >
      <path
        d={pathD}
        stroke={strokeColor}
        strokeWidth={strokeWidth}
        strokeDasharray={dashArray}
        fill="none"
        className={active ? styles.crawlingAnt : ''}
      />
      <circle cx={x2} cy={y2} r={3} fill={strokeColor} />
    </svg>
  );
};

export default WavyConnectorLine;
